import MainConnection from "./MainConnection";
import AlertManager from "../managers/AlertManager";

export default {
  requestCoverageAreas: async function(bounds, zoom) {
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();
    const requestBoundString =
      ne.lat() + "," + ne.lng() + "," + sw.lat() + "," + sw.lng();
    try {
      const requestURL =
        "/maps/area?bounds=" + requestBoundString + "&zoom=" + zoom;
      const response = await MainConnection.request().get(requestURL);

      switch (response.data.code) {
        case "0":
          return response.data.data.data;

        default:
          AlertManager.showBusinessErrorAlertDialog(
            response.data.code,
            response.data.message
          );
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestLocationServiceAvailable: async function(locationLatLng) {
    try {
      const requestURL =
        "/maps/checkService?latitude=" +
        locationLatLng.lat +
        "&longtitude=" +
        locationLatLng.lng;

      const response = await MainConnection.request().get(requestURL);
      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showBusinessErrorAlertDialog(
            response.data.code,
            response.data.message
          );
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestSiteServiceAvailable: async function(locationLatLng) {
    try {
      const requestURL =
        "/maps/token?latitude=" +
        locationLatLng.lat +
        "&longitude=" +
        locationLatLng.lng;

      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // GET : Geosearch autocomplete data as array with limit
  requestAutoComplete: async function(searchKeyword) {
    try {
      const response = await MainConnection.request().get(
        "/geo/autocomplete?keyword=" + searchKeyword + "&maxResult=5"
      );
      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showErrorSnackbar("Error: " + response.message);
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // GET : Geosearch location data
  requestLocationDetail: async function(locationId, lang) {
    try {
      const response = await MainConnection.request().get(
        "/geo/location?location_id=" + locationId + "&language=" + lang
      );
      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showErrorSnackbar("Error: " + response.message);
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  // GET : Geosearch location-ID
  requestLocationId: async function(address) {
    try {
      const response = await MainConnection.request().get(
        "/geo/search?input=" + address
      );
      switch (response.data.code) {
        case "0":
          return response.data.data;

        default:
          AlertManager.showErrorSnackbar("Error: " + response.message);
          break;
      }
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  }
};
